import store from "../../store/store"
import { KnowledgeBaseHub } from "../hubs/knowledgeBase"

export const knowledgeBaseHub = new KnowledgeBaseHub(store)
